
let importModule = () => {
	return import(/* webpackChunkName: "columnsFiltersControl" */ './module').then((module) => {
		return module;

	}).catch(error => console.error(error, 'An error occurred while loading the "filtersControls" component'));
}

(window as any).initDateRangeFilter = function (target: HTMLElement, aoColumn, id, val, separator: string) {

	var input = document.createElement("input");
	input.value = val;
	input.type = "hidden";
	input.classList.add("filter");
	input.classList.add("react-autocomplete-filter");
	input.name = aoColumn.sName;
	input.id = id;
	target.appendChild(input);

	const contener = createDivContainer();
	target.appendChild(contener);

	importModule().then(module => {
		if (module)
			module.default.renderDateRange(contener, aoColumn, id, val, separator);
	});
};

(window as any).initUsersGridFilter = function (target: HTMLElement, aoColumn, id, val) {
	var input = document.createElement("input");
	input.value = val;
	input.type = "hidden";
	input.classList.add("filter");
	input.classList.add("react-autocomplete-filter");
	input.name = aoColumn.sName;
	input.id = id;
	target.appendChild(input);

	const contener = createDivContainer();
	target.appendChild(contener);

	importModule().then(module => {
		if (module)
			module.default.renderUsersGridFiter(contener, aoColumn, id, val);
	});
};

(window as any).initLogPlusResourcesGridFilter = function (target: HTMLElement, aoColumn, id, val) {
	var input = document.createElement("input");
	input.value = val;
	input.type = "hidden";
	input.classList.add("filter");
	input.classList.add("react-autocomplete-filter");
	input.name = aoColumn.sName;
	input.id = id;
	target.appendChild(input);

	const contener = createDivContainer();
	target.appendChild(contener);

	importModule().then(module => {
		if (module)
			module.default.renderLogPlusResources(contener, aoColumn, id, val);
	});
};

(window as any).initWatchersFilter = function (target: HTMLElement, aoColumn, id, val) {
	var input = document.createElement("input");
	input.value = val;
	input.type = "hidden";
	input.classList.add("filter");
	input.classList.add("react-autocomplete-filter");
	input.name = aoColumn.sName;
	input.id = id;
	target.appendChild(input);

	const contener = createDivContainer();
	target.appendChild(contener);

	importModule().then(module => {
		if (module)
			module.default.renderWatchers(contener, aoColumn, id, val);
	});
};

(window as any).initWatcherGroupsFilter = function (target: HTMLElement, aoColumn, id, val) {
	var input = document.createElement("input");
	input.value = val;
	input.type = "hidden";
	input.classList.add("filter");
	input.classList.add("react-autocomplete-filter");
	input.name = aoColumn.sName;
	input.id = id;
	target.appendChild(input);

	const contener = createDivContainer();
	target.appendChild(contener);

	importModule().then(module => {
		if (module)
			module.default.renderWatcherGroups(contener, aoColumn, id, val);
	});
};

(window as any).initEnumSelectFilter = function (target: HTMLElement, aoColumn, id, val) {
	var input = document.createElement("input");
	input.value = val;
	input.type = "hidden";
	input.classList.add("filter");
	input.classList.add("react-autocomplete-filter");
	input.name = aoColumn.sName;
	input.id = id;
	target.appendChild(input);

	const contener = createDivContainer();
	target.appendChild(contener);

	importModule().then(module => {
		if (module)
			module.default.renderEnumSelect(contener, aoColumn, id, val);
	});
};

(window as any).initTextInputFilter = function (target: HTMLElement, aoColumn, id, val) {
	var input = document.createElement("input");
	input.value = val;
	input.type = "hidden";
	input.classList.add("filter");
	input.classList.add("react-text-input-filter");
	input.name = aoColumn.sName;
	input.id = id;
	target.appendChild(input);

	const contener = createDivContainer();
	target.appendChild(contener);

	importModule().then(module => {
		if (module)
			module.default.renderTextInputFilter(contener, aoColumn, id, val);
	});
};

function createDivContainer() {
	var contener = document.createElement("div");
	contener.classList.add("column-filter-contener");
	return contener;
}